import { Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { actionHandler } from '../../../../utilities/form/formUtils';
import { setTrygTealium } from '../../../../utilities/tracking';

// Components
import Label from '../../../Form/Label';
import Description from '../../../Form/Description';
import Icon from '../../../Global/Icon';

class InputRadioButtons extends Component {
  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(event) {
    const {
      actions,
      dispatch,
      onChange,
      id,
      groupName,
      updateRadio,
      setFieldValue,
      label,
      tealiumMap,
      values,
    } = this.props;
    // Fire Update Radio Function
    updateRadio(groupName, id);
    if (setFieldValue) {
      const name = `${[groupName]}Text`;
      setFieldValue(name, label);
    }
    if (tealiumMap) {
      const trackingData = {
        [tealiumMap]: label,
      };
      setTrygTealium(trackingData);
    }
    // If isLink then the action should be fired on the label, and not the checkbox
    if (actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, { ...values, setFieldValue });
    } else {
      onChange(event);
    }
  }

  render() {
    const {
      desc,
      groupName,
      id,
      label,
      onBlur,
      required,
      activeRadio,
      icon,
      radioType,
      hidden,
    } = this.props;

    const radioGroupClass = classNames('form__field', 'form__field--radio-buttons', {
      [`form__field-radio--${radioType}`]: radioType,
      'hidden': hidden,
    });
    return (
      <div className={radioGroupClass}>

        {/* Input Field */}
        <input
          className="form__item"
          type="radio"
          name={groupName}
          id={id}
          value={id}
          required={required}
          onBlur={onBlur}
          onChange={e => this.onChangeHandler(e)}
          checked={activeRadio === id}
          tabIndex={0}
          aria-checked={activeRadio === id}
          aria-labelledby={id}
        />

        <div className={`form__item-box form__item--${radioType}`}>

          {icon &&
          <Icon icon={icon}/>
          }

          {/* Label */}
          {label && (!radioType || (radioType && radioType !== 'round')) &&
          <span className="form__radio--label">
            <Label id={id} label={label} className={`form__label form__label--${radioType}`}/>
          </span>
          }

          {label && radioType && radioType === 'round' &&
          <span className="form__radio--round">
            <Label id={id} label={label} className={ activeRadio === id ? 'form__label--round active' : 'form__label--round'}/>
          </span>
          }


          {/* Description */}
          {desc &&
          <Description desc={desc}/>
          }

        </div>

      </div>
    );
  }
}

export default InputRadioButtons;

InputRadioButtons.defaultProps = {
  label: null,
  desc: null,
  icon: null,
  required: false,
  actions: [],
  radioType: '',
  tealiumMap: null,
  hidden: false,
};

InputRadioButtons.propTypes = {
  id: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  activeRadio: PropTypes.string,
  updateRadio: PropTypes.func.isRequired,
  actions: PropTypes.array,
  required: PropTypes.bool,
  label: PropTypes.string,
  desc: PropTypes.string,
  icon: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  radioType: PropTypes.string,
  tealiumMap: PropTypes.string,
  values: PropTypes.object.isRequired,
  hidden: PropTypes.bool,
};
